import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CoreModule} from './core/core.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LayoutModule} from '@app/modules/layout/layout.module';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {Observable} from 'rxjs';
import {CsrfInitializerService} from '@app/shared/service/csrf-initializer.service';

@NgModule({
	declarations: [
		AppComponent
	],
	imports: [
		CoreModule,
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		LayoutModule,
		MatSnackBarModule
	],
	providers: [
		{
			// Ensures that a CSRF token cookie is obtained from the backend on application startup.
			// Without a CSRF token up-front, the first request to an endpoint
			// that requires CSRF protection (e.g. login) will fail.
			provide: APP_INITIALIZER,
			useFactory: initializeCsrf,
			deps: [CsrfInitializerService],
			multi: true
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule {
}

function initializeCsrf(svc: CsrfInitializerService): () => Observable<void> {
	return () => svc.initializeCsrf();
}
